import React, { useEffect, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";

import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ColumnTable from "../embrillTable/ColumnTable";
import PricingForm from "components/allForm/Pricing/PricingForm";
import { fetchAsyncGetPricing } from "redux/pricingSlice";
import { pricingDataColumns } from "../embrillTable/variables/organization";

const AllPricing = () => {
  const [addNewModal, setAddNewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [pricingEditData, setPricingEditData] = useState(null);
  const [pricingListData, setPricingListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [loading, setLoading] = useState(false);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Pricing');
      if(roleObj){

        setRole(roleObj?.access)
      }
    }
   
  },[currUser])


  const pricingList = useSelector((state) => state.pricingData);
  const dispatch = useDispatch();
  const handleModalOpen = () => {
    setAddNewModal(true);
  };
  const handleModalClose = () => {
    setAddNewModal(false);
    setOpenEditModal(false);
    setPricingEditData(null);
  };

  useEffect(() => {
    const fetchPricing = async () => {
      setLoading(true);
      try {
        await dispatch(fetchAsyncGetPricing());
      } catch (error) {
        console.error("Failed to fetch pricing:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, [dispatch]);

  
  useEffect(() => {
    if (pricingList && pricingList.length > 0) {
      const tableData = pricingList.map((data, index) => {
        return {
          _id:data?._id,
          no: index + 1,
          name: data.name,
          description:data?.dec,
          userLimit:data?.uLmt,
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e,data._id)
                }}
              />
             
            </div>
          ),
        };
      });
      setPricingListData(tableData);
    } else {
      setPricingListData([]);
    }
  }, [pricingList,role]);

  
  const handlerRefreshData = () => {
    dispatch(fetchAsyncGetPricing());
  };

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = pricingList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setPricingEditData(data[0]);
    handleModalOpen();
  }
  const textColor = useColorModeValue("secondaryGray.900", "white");

  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box display="flex" className="mx-0" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
          mx={2}
        >
          Pricing Type
        </Text>
       
        </Box>
        <Box display="flex" mt={4} className="add-new-btn">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleModalOpen}
          >
            <FaPlus size={12} className="new-plus-icon"/> New
          </Box>
            
        </Box>
     
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={pricingDataColumns}
          tableData={pricingListData}
          type={"Pricing Type"}
          role={role}
          openInfoModal = {handleRowClick}
          expenseType = 'pricing'
        />
      </Box>
      {addNewModal && (
        <PricingForm
          openModel={addNewModal}
          closeModel={handleModalClose}
          isEdit={openEditModal}
          editData={pricingEditData}
          refreshList={handlerRefreshData}
          role={role}

        />
      )}
    </>
  );
};

export default AllPricing;